import AboutHero from "../Components/Abouthero";
import Journey from "../Components/Journey";
import EarlyLife from "../Components/Earlylife";
import Cg from "../Components/Cg";
import Milestones from "../Components/Milestone";

const Aboutuspage = () => {
  return (
    <>
    <section id="AboutHero">
        <AboutHero />
      </section>

      <section id="journey">
        <Journey />
      </section>

      <section id="cg">
        <Cg />
      </section>

      <section id="earlylife">
        <EarlyLife />
      </section>

      <section id="milestone">
        <Milestones />
      </section>

    </>
  );
};

export default Aboutuspage;
